/**
* @name: LayoutFooter
* @author: weiyong
* @date: 2022-10-01 08:43
* @description：LayoutFooter
* @update: 2022-10-01 08:43
*/
<template>

</template>

<script>
export default {
  name: "LayoutFooter"
}
</script>

<script lang="ts" setup>

</script>

<style type="text/css" lang="less"></style>
